"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var DefaultDevicePixelRatioMonitor_1 = require("../devicepixelratiomonitor/DefaultDevicePixelRatioMonitor");
var DevicePixelRatioWindowSource_1 = require("../devicepixelratiosource/DevicePixelRatioWindowSource");
var Types_1 = require("../utils/Types");
var DefaultVideoTileController = /*#__PURE__*/function () {
  function DefaultVideoTileController(tileFactory, audioVideoController, logger) {
    _classCallCheck(this, DefaultVideoTileController);
    this.tileFactory = tileFactory;
    this.audioVideoController = audioVideoController;
    this.logger = logger;
    this.tileMap = new Map();
    this.nextTileId = 1;
    this.currentLocalTile = null;
    this.currentPausedTilesByIds = new Set();
    this.keepLastFrameWhenPaused = false;
    this.keepLastFrameWhenPaused = audioVideoController.configuration.keepLastFrameWhenPaused;
  }
  _createClass(DefaultVideoTileController, [{
    key: "createDevicePixelRatioMonitorIfNeeded",
    value: function createDevicePixelRatioMonitorIfNeeded() {
      if (this.devicePixelRatioMonitor) {
        return;
      }
      this.devicePixelRatioMonitor = new DefaultDevicePixelRatioMonitor_1.default(new DevicePixelRatioWindowSource_1.default(), this.logger);
    }
  }, {
    key: "discardDevicePixelRatioMonitorIfNotNeeded",
    value: function discardDevicePixelRatioMonitorIfNotNeeded() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var monitor;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.tileMap.size || !this.devicePixelRatioMonitor)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              monitor = this.devicePixelRatioMonitor;
              this.devicePixelRatioMonitor = undefined;
              return _context.abrupt("return", monitor.destroy());
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "bindVideoElement",
    value: function bindVideoElement(tileId, videoElement) {
      var tile = this.getVideoTile(tileId);
      if (tile === null) {
        this.logger.warn("Ignoring video element binding for unknown tile id ".concat(tileId));
        return;
      }
      tile.bindVideoElement(videoElement);
    }
  }, {
    key: "unbindVideoElement",
    value: function unbindVideoElement(tileId) {
      this.bindVideoElement(tileId, null);
    }
  }, {
    key: "startLocalVideoTile",
    value: function startLocalVideoTile() {
      var tile = this.findOrCreateLocalVideoTile();
      this.currentLocalTile.stateRef().localTileStarted = true;
      this.audioVideoController.update({
        needsRenegotiation: true
      });
      return tile.id();
    }
  }, {
    key: "stopLocalVideoTile",
    value: function stopLocalVideoTile() {
      if (!this.currentLocalTile) {
        return;
      }
      this.currentLocalTile.stateRef().localTileStarted = false;
      this.currentLocalTile.bindVideoStream(this.audioVideoController.configuration.credentials.attendeeId, true, null, null, null, null, this.audioVideoController.configuration.credentials.externalUserId);
      this.audioVideoController.update({
        needsRenegotiation: true
      });
    }
  }, {
    key: "hasStartedLocalVideoTile",
    value: function hasStartedLocalVideoTile() {
      return !!(this.currentLocalTile && this.currentLocalTile.stateRef().localTileStarted);
    }
  }, {
    key: "removeLocalVideoTile",
    value: function removeLocalVideoTile() {
      if (this.currentLocalTile) {
        this.removeVideoTile(this.currentLocalTile.id());
      }
    }
  }, {
    key: "getLocalVideoTile",
    value: function getLocalVideoTile() {
      return this.currentLocalTile;
    }
  }, {
    key: "pauseVideoTile",
    value: function pauseVideoTile(tileId) {
      var tile = this.getVideoTile(tileId);
      if (tile) {
        if (!this.currentPausedTilesByIds.has(tileId)) {
          this.audioVideoController.pauseReceivingStream(tile.stateRef().streamId);
          this.currentPausedTilesByIds.add(tileId);
        }
        tile.pause();
      }
    }
  }, {
    key: "unpauseVideoTile",
    value: function unpauseVideoTile(tileId) {
      var tile = this.getVideoTile(tileId);
      if (tile) {
        if (this.currentPausedTilesByIds.has(tileId)) {
          this.audioVideoController.resumeReceivingStream(tile.stateRef().streamId);
          this.currentPausedTilesByIds.delete(tileId);
        }
        tile.unpause();
      }
    }
  }, {
    key: "getVideoTile",
    value: function getVideoTile(tileId) {
      return this.tileMap.has(tileId) ? this.tileMap.get(tileId) : null;
    }
  }, {
    key: "getVideoTileArea",
    value: function getVideoTileArea(tile) {
      var state = tile.state();
      var tileHeight = 0;
      var tileWidth = 0;
      if (state.boundVideoElement) {
        tileHeight = state.boundVideoElement.clientHeight * state.devicePixelRatio;
        tileWidth = state.boundVideoElement.clientWidth * state.devicePixelRatio;
      }
      return tileHeight * tileWidth;
    }
  }, {
    key: "getAllRemoteVideoTiles",
    value: function getAllRemoteVideoTiles() {
      var _this = this;
      var result = new Array();
      this.tileMap.forEach(function (tile, tileId) {
        if (!_this.currentLocalTile || tileId !== _this.currentLocalTile.id()) {
          result.push(tile);
        }
      });
      return result;
    }
  }, {
    key: "getAllVideoTiles",
    value: function getAllVideoTiles() {
      return Array.from(this.tileMap.values());
    }
  }, {
    key: "addVideoTile",
    value: function addVideoTile() {
      var localTile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var tileId = this.nextTileId;
      this.nextTileId += 1;
      this.createDevicePixelRatioMonitorIfNeeded();
      var tile = this.tileFactory.makeTile(tileId, localTile, this, this.devicePixelRatioMonitor);
      this.tileMap.set(tileId, tile);
      return tile;
    }
  }, {
    key: "removeVideoTile",
    value: function removeVideoTile(tileId) {
      if (!this.tileMap.has(tileId)) {
        return;
      }
      var tile = this.tileMap.get(tileId);
      if (this.currentLocalTile === tile) {
        this.currentLocalTile = null;
      }
      tile.destroy();
      this.tileMap.delete(tileId);
      this.audioVideoController.forEachObserver(function (observer) {
        Types_1.Maybe.of(observer.videoTileWasRemoved).map(function (f) {
          return f.bind(observer)(tileId);
        });
      });
      this.discardDevicePixelRatioMonitorIfNotNeeded();
    }
  }, {
    key: "removeVideoTilesByAttendeeId",
    value: function removeVideoTilesByAttendeeId(attendeeId) {
      var tilesRemoved = [];
      var _iterator = _createForOfIteratorHelper(this.getAllVideoTiles()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tile = _step.value;
          var state = tile.state();
          if (state.boundAttendeeId === attendeeId) {
            this.removeVideoTile(state.tileId);
            tilesRemoved.push(state.tileId);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return tilesRemoved;
    }
  }, {
    key: "removeAllVideoTiles",
    value: function removeAllVideoTiles() {
      var tileIds = Array.from(this.tileMap.keys());
      for (var _i = 0, _tileIds = tileIds; _i < _tileIds.length; _i++) {
        var tileId = _tileIds[_i];
        this.removeVideoTile(tileId);
      }
    }
  }, {
    key: "sendTileStateUpdate",
    value: function sendTileStateUpdate(tileState) {
      this.audioVideoController.forEachObserver(function (observer) {
        Types_1.Maybe.of(observer.videoTileDidUpdate).map(function (f) {
          return f.bind(observer)(tileState);
        });
      });
    }
  }, {
    key: "haveVideoTilesWithStreams",
    value: function haveVideoTilesWithStreams() {
      var _iterator2 = _createForOfIteratorHelper(this.getAllVideoTiles()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var tile = _step2.value;
          if (tile.state().boundVideoStream) {
            return true;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return false;
    }
  }, {
    key: "haveVideoTileForAttendeeId",
    value: function haveVideoTileForAttendeeId(attendeeId) {
      return !!this.getVideoTileForAttendeeId(attendeeId);
    }
  }, {
    key: "getVideoTileForAttendeeId",
    value: function getVideoTileForAttendeeId(attendeeId) {
      var _iterator3 = _createForOfIteratorHelper(this.getAllVideoTiles()),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var tile = _step3.value;
          var state = tile.state();
          if (state.boundAttendeeId === attendeeId) {
            return tile;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return undefined;
    }
  }, {
    key: "captureVideoTile",
    value: function captureVideoTile(tileId) {
      var tile = this.getVideoTile(tileId);
      if (!tile) {
        return null;
      }
      return tile.capture();
    }
  }, {
    key: "findOrCreateLocalVideoTile",
    value: function findOrCreateLocalVideoTile() {
      if (this.currentLocalTile) {
        return this.currentLocalTile;
      }
      this.currentLocalTile = this.addVideoTile(true);
      this.currentLocalTile.bindVideoStream(this.audioVideoController.configuration.credentials.attendeeId, true, null, null, null, null, this.audioVideoController.configuration.credentials.externalUserId);
      return this.currentLocalTile;
    }
  }]);
  return DefaultVideoTileController;
}();
exports.default = DefaultVideoTileController;